import { createEvent } from 'effector';
import { createGate } from 'effector-react';

export const sendOverviewCallEv = createEvent();

export const changeShowProjectDotsEv = createEvent();

export const changeActiveProblemRespEv = createEvent();

export const getProblemProjectsEv = createEvent();

export const setIsModalOpenEv = createEvent();

export const getDashboardsDataEv = createEvent();
export const setDashboardModalOpenEv = createEvent();

export const ManufacturersGate = createGate();
export const setOtpModalEv = createEvent();
export const resetOtpModalEv = createEvent();

export const sendOtpCallEv = createEvent();

export const setBizModalEv = createEvent();
export const resetBizModalEv = createEvent();

export const setDistrictModalEv = createEvent();
export const resetDistrictModalEv = createEvent();

export const setBizPollsStatsModalEv = createEvent();
export const resetBizPollsStatsModalEv = createEvent();
export const BizPollsStatsModalGate = createGate();
export const BizPollsStatsYearDetailsModalGate = createGate();

export const downloadProjectsEv = createEvent();

export const toggleClusterInfoModalEv = createEvent();
export const resetClusterInfoModalEv = createEvent();

export const changeClusterSelectEv = createEvent();
export const changeClusterNicheEv = createEvent();
export const resetNicheClusters = createEvent();

export const changeClusterProblemDetailsEv = createEvent();

export const changeClusterModalTitleEv = createEvent();

export const setBizPollsAnswerDetailsModalEv = createEvent();
export const resetBizPollsAnswerDetailsModalEv = createEvent();
